import * as api from "@/api/williams/welders";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function useWelderLookup(search: string) {
  return useQuery(queryKeys.welder.search(search), () => {
    return api.getWelderLookup(search);
  });
}
